'use strict';

const { default: openModal } = require('App/services/Modal/Modal');
const { openEditOrder } = require('App/components/EditOrder');

angular.module('upDirectives').directive('upEventEsign', function () {
	return {
		restrict: 'A',
		templateUrl: require('App/upsales/common/directives/event/upEventEsign.tpl.html?file'),
		require: 'upEventEsign',
		scope: {
			event: '=upEventEsign',
			noIcon: '@'
		},
		controller: [
			'$scope',
			function ($scope) {
				$scope.customerId = Tools.AppService.getCustomerId();

				$scope.openEsign = function () {
					var options = {
						id: $scope.event.entityId
					};

					openModal('ConfirmEsignModal', options);
				};

				$scope.openOpportunity = () => openEditOrder({ id: $scope.event.esign.opportunity.id });
			}
		]
	};
});
